import { render, staticRenderFns } from "./LineupCard.vue?vue&type=template&id=8731c37a&scoped=true&"
import script from "./LineupCard.vue?vue&type=script&lang=ts&"
export * from "./LineupCard.vue?vue&type=script&lang=ts&"
import style0 from "./LineupCard.vue?vue&type=style&index=0&id=8731c37a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8731c37a",
  null
  
)

export default component.exports